/* eslint-disable no-underscore-dangle */
import PouchDB from 'pouchdb';
import { get } from '../utils/api';
import { upsert } from './common';

class StoreFromFile {
  constructor(name) {
    this.db = new PouchDB(name);
  }

  save = (response, onSuccess) => {
    upsert(this.db, this.storeSavedName, response.data, onSuccess);
  };

  fetchAndSave = (onSuccess) => get(this.endpoint).then((response) => this.save(response, onSuccess));

  load = (callback) => {
    this.db
      .get(this.storeSavedName)
      .then((doc) => {
        callback(doc);
      })
      .then(() => {})
      .catch(() => {
        callback();
      });
  };
}

export default StoreFromFile;
